import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";

import { APP_INFO } from "../../constants/AppInfo"; // Assuming you have a constants file

import "./LoginModal.css"; // Your custom CSS

import AuthService from "../../services/AuthService";
import storage from "../../utils/storage";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";

const LoginModal = ({ show, onHide }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState("");
  const [loginForm, setLoginForm] = useState(true);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [token, setToken] = useState("");
  const [timer, setTimer] = useState(30);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  // Handle send OTP
  const handleSendOTP = async () => {
    if (mobile.length !== 10) {
      Swal.fire(
        "Opps!",
        "Please enter a valid 10-digit mobile number.",
        "error",
      );
      return;
    }

    setLoading(true);

    try {
      const result = await AuthService.loginWithMobile(mobile);

      if (!result.success) {
        Swal.fire("Opps!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        setToken(responseData.data.token);
        setLoginForm(false);
      } else {
        Swal.fire("Opps!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Opps!",
        "Request Failed:",
        error.response?.data || error.message,
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle OTP verify
  const handleOtpVerify = async () => {
    const combinedOtp = otp.join("");
    if (combinedOtp.length !== 6) {
      Swal.fire("Opps!", "Please enter a complete 6-digit OTP", "error");
      return;
    }

    setLoading(true);

    try {
      const result = await AuthService.verifyOtp(combinedOtp, token);

      if (!result.success) {
        Swal.fire("Opps!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        var data = responseData.data;

        // Extract user data from response
        const accessToken = data.access_token;
        const userId = data.user_id;
        const mobile = data.mobile;
        const userType = data.user_type;
        const name = data.name;

        // Store user data in storage
        storage.setItem("access_token", accessToken);
        storage.setItem("user_id", userId);
        storage.setItem("mobile", mobile);
        storage.setItem("user_type", userType);
        storage.setItem("name", name);

        onHide();
        window.location.reload();
      } else {
        Swal.fire("Opps!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Opps!",
        "Request Failed:",
        error.response?.data || error.message,
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle OTP input change
  const handleOtpChange = (index, value) => {
    if (/^\d*$/.test(value) && value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto focus to next input
      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  // Handle backspace
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  // Timer countdown
  useEffect(() => {
    let interval;
    if (timer > 0 && isResendDisabled) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsResendDisabled(false);
    }
    return () => clearInterval(interval);
  }, [timer, isResendDisabled]);

  // Reset timer when resend is clicked
  const handleResendOtp = () => {
    // onResendOtp();
    setTimer(30);
    setIsResendDisabled(true);
    setOtp(["", "", "", "", "", ""]);
    document.getElementById("otp-input-0").focus();
  };

  return (
    <React.Fragment>
      {loading && <LoadingScreen />}

      <Modal
        show={show}
        onHide={onHide}
        centered
        size="xl"
        aria-labelledby="loginModalLabel"
        className="login-modal"
      >
        <Modal.Body className="p-0">
          <div className="login-modal-content">
            {/* Close Button */}
            <Button
              variant="link"
              className="p-0 position-absolute top-0 end-0 m-3"
              onClick={onHide}
              aria-label="Close"
            >
              <i className="fas fa-times fs-4"></i>
            </Button>

            <div
              className="d-flex flex-column flex-md-row"
              style={{ height: "75vh" }}
            >
              {/* Left Panel - QR Section (hidden on mobile) */}
              <div className="w-100 w-md-50 bg-light d-none d-md-flex flex-column align-items-center justify-content-center p-4">
                <img
                  src="/assets/images/logo.png"
                  alt="Logo"
                  style={{ height: "60px", marginBottom: "20px" }}
                />

                <h5 className="fw-bold text-center mb-2">
                  Welcome to {APP_INFO.appName}
                </h5>
                <p className="text-center small mb-3 px-3">
                  Powering recharges, bills, and brand vouchers nationwide.
                </p>

                {/* <div className="qr-wrapper shadow mb-2">
                  <img
                    src="/assets/images/qr-code.png"
                    alt="QR Code"
                    className="img-fluid"
                    width={200}
                  />
                </div>
                <p className="text-center small mb-3">
                  <strong>Scan to download our app</strong>
                  <br />
                  For smooth & fast experience
                </p>

                <a
                  href="https://play.google.com/store"
                  className="btn btn-dark w-100 d-flex align-items-center justify-content-center gap-2 mb-3"
                >
                  Download App
                </a>

        
                <div className="d-flex flex-wrap justify-content-center gap-3 mt-3">
                  <div className="text-center">
                    <img
                      src="/assets/images/secured-icon.png"
                      alt="Secure"
                      className="feature-icon"
                    />
                    <div className="small">Safe and Secured</div>
                  </div>
                  <div className="text-center">
                    <img
                      src="/assets/images/rupee-icon.png"
                      alt="Cashback"
                      className="feature-icon"
                    />
                    <div className="small">Realtime Cashback</div>
                  </div>
                  <div className="text-center">
                    <img
                      src="/assets/images/happy-user-icon.png"
                      alt="Transactions"
                      className="feature-icon"
                    />
                    <div className="small">Join 10 Lakh+ Happy Users</div>
                  </div>
                </div>*/}
              </div>

              {/* Right Panel - Login Section (always visible) */}
              <div className="w-100 w-md-50 d-flex flex-column justify-content-center p-4 overflow-auto">
                {loginForm ? (
                  <>
                    <h5 className="fw-bold mb-2">
                      Login to {APP_INFO.appName}
                    </h5>
                    <p className="small text-muted mb-3">
                      Enter your mobile number to receive OTP.
                    </p>

                    <input
                      type="text"
                      className="form-control mb-3"
                      placeholder="Enter 10-digit mobile number"
                      value={mobile}
                      onChange={(e) =>
                        setMobile(e.target.value.replace(/\D/g, ""))
                      }
                      maxLength="10"
                    />

                    <Button
                      variant="primary"
                      className="w-100"
                      onClick={handleSendOTP}
                      disabled={loading}
                    >
                      {loading ? "Processing..." : "Send OTP"}
                    </Button>
                  </>
                ) : (
                  <div className="d-flex flex-column align-items-center">
                    <div className="mb-2">
                      <h4 className="fw-bold mb-2 text-center">Verify OTP</h4>
                      <p className="text-muted">
                        Enter the 6-digit OTP sent to{" "}
                        <span className="fw-bold">+91 {mobile}</span>
                      </p>
                    </div>

                    <div className="d-flex justify-content-center gap-2 mb-4">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-input-${index}`}
                          type="text"
                          className="form-control text-center otp-input"
                          style={{
                            width: "45px",
                            height: "50px",
                            fontSize: "1.2rem",
                          }}
                          value={digit}
                          onChange={(e) =>
                            handleOtpChange(index, e.target.value)
                          }
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          maxLength={1}
                          autoFocus={index === 0}
                        />
                      ))}
                    </div>

                    <Button
                      variant="primary"
                      className="w-100 py-2 mb-3"
                      onClick={handleOtpVerify}
                    >
                      Verify OTP
                    </Button>

                    <div className="text-center">
                      <p className="text-muted">
                        Didn't receive OTP?{" "}
                        {isResendDisabled ? (
                          <span className="fw-bold">Resend in {timer}s</span>
                        ) : (
                          <button
                            className="btn btn-link p-0 text-decoration-none fw-bold"
                            onClick={handleResendOtp}
                          >
                            Resend OTP
                          </button>
                        )}
                      </p>
                    </div>
                  </div>
                )}

                <p className="text-center small text-muted mt-3">
                  By continuing you agree to our{" "}
                  <a href="/terms-and-conditions">Terms & Conditions</a> and{" "}
                  <a href="/privacy-policy">Privacy Policy</a>.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default LoginModal;
